export const checkSecrets = (excludeVars = []) => {
  Object.keys(process.env)
    .filter(key => key.startsWith('REACT_APP_'))
    .forEach(key => {
      if (!process.env[key] && !excludeVars.includes(key)) {
        throw new Error(`the environment variables ${key} is missing`)
      }
    })
}

export const getSecret = key => {
  if (!process.env[key]) {
    throw new Error(`the environment variables ${key} is missing`)
  }
  return process.env[key]
}
